
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gradient-to-b from-white via-[#F6C1A1]/10 to-white">
      <div className="absolute top-20 right-10 w-96 h-96 bg-[#F2A35E]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-80 h-80 bg-[#9B5E6B]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-8">
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-tight text-[#0F0F0F]">
              Elevate Your<br />
              OnlyFans<br />
              <span className="bg-gradient-to-r from-[#9B5E6B] to-[#F2A35E] bg-clip-text text-transparent">
                Success
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-[#7B4A5A] font-medium max-w-2xl leading-relaxed">
              Caribbean-based expertise meets world-class management. We transform content creators into thriving businesses with personalized strategies and dedicated support.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button onClick={() => scrollToSection('contact')} className="px-8 py-4 bg-[#C77A5A] text-white text-base font-semibold rounded-lg shadow-lg hover:shadow-xl hover:bg-[#9B5E6B] transition-all duration-300 whitespace-nowrap cursor-pointer">
                Get Started
              </button>
              <button onClick={() => scrollToSection('statistics')} className="px-8 py-4 border-2 border-[#9B5E6B] text-[#9B5E6B] text-base font-semibold rounded-lg hover:bg-[#9B5E6B] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                View Our Results
              </button>
            </div>
          </div>
          
          <div className="lg:col-span-2 relative">
            <div className="relative z-10 space-y-6">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl transform rotate-3 hover:rotate-0 transition-transform duration-300 border border-[#F6C1A1]">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium text-[#7B4A5A]">Monthly Revenue</span>
                  <i className="ri-arrow-up-line text-[#F2A35E] text-xl"></i>
                </div>
                <p className="text-4xl font-bold bg-gradient-to-r from-[#9B5E6B] to-[#F2A35E] bg-clip-text text-transparent">$56K</p>
                <p className="text-sm text-[#C77A5A] mt-2">+245% growth</p>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl transform -rotate-3 hover:rotate-0 transition-transform duration-300 border border-[#F6C1A1] ml-8">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium text-[#7B4A5A]">Active Subscribers</span>
                  <i className="ri-user-heart-line text-[#F2A35E] text-xl"></i>
                </div>
                <p className="text-4xl font-bold bg-gradient-to-r from-[#9B5E6B] to-[#F2A35E] bg-clip-text text-transparent">1,542</p>
                <p className="text-sm text-[#C77A5A] mt-2">+180% this quarter</p>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl transform rotate-2 hover:rotate-0 transition-transform duration-300 border border-[#F6C1A1]">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium text-[#7B4A5A]">Engagement Rate</span>
                  <i className="ri-heart-pulse-line text-[#F2A35E] text-xl"></i>
                </div>
                <p className="text-4xl font-bold bg-gradient-to-r from-[#9B5E6B] to-[#F2A35E] bg-clip-text text-transparent">94.7%</p>
                <p className="text-sm text-[#C77A5A] mt-2">Industry leading</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
